import React from 'react';


const VisionStatement = () => {
  return null;
};

export default VisionStatement;